<template>
  <div class="howitworks">
    <!-- <div class="w-90 m-auto">
      <h2 class="px-4 mb-5 font-weight-bold">How TalentAlt Works</h2>
      <div class="row">       
        <div class="col-lg-3 w-90 m-auto">
          <div class="card mb-4 match-height shadow-lg">
            <div class="row">
              <div class="col-sm-12 col-md-4 col-lg-12 ">
                  <img src="../assets/KOVATEK/IMAGES/kovatek-note.png" class="card-img-top kova-img" alt="...">
              </div>
              <div class="col-sm-12 col-md-8 col-lg-12 ">
                <div class="card-body">
              <h6 class="card-title text-left font-weight-bold">Get Started</h6>
              <p class="card-text text-left">Provide project information. Your account manager will then contact you for
                detail requirements and answer any question
              </p>
              </div>
            </div>
            
            </div>
          </div>
        </div>
        <div class="col-lg-3 w-90 m-auto">
          <div class="card mb-4 match-height shadow-lg">
            <div class="row">
              <div class="col-sm-12 col-md-4 col-lg-12 ">
                  <img src="../assets/KOVATEK/IMAGES/kovatek-home.png" class="card-img-top kova-img" alt="...">
              </div>
              <div class="col-sm-12 col-md-8 col-lg-12 ">
                <div class="card-body">
              <h6 class="card-title text-left font-weight-bold">Hire Developers and meet your needs</h6>
              <p class="card-text text-left">Developers that meet your product requirement specifications will be assigned and/or bid
                for your project task. You review,approve and hire.
              </p>
              </div>
            </div>
            
            </div>
          </div>
        </div>
        <div class="col-lg-3 w-90 m-auto">
          <div class="card mb-4 match-height shadow-lg">
            <div class="row">
              <div class="col-sm-12 col-md-4 col-lg-12 ">
                  <img src="../assets/KOVATEK/IMAGES/kovatek-web.png" class="card-img-top kova-img" alt="...">
              </div>
              <div class="col-sm-12 col-md-8 col-lg-12 ">
                <div class="card-body">
              <h6 class="card-title text-left font-weight-bold">Collaborate and Scale</h6>
              <p class="card-text text-left">Hire all your developers and use TalentAlt project board to track your project activites.
                Your product development is enriched with kovatek management assistance
              </p>
              </div>
            </div>
            
            </div>
          </div>
        </div>
        <div class="col-lg-3 w-90 m-auto">
          <div class="card mb-4 match-height shadow-lg">
            <div class="row">
              <div class="col-sm-12 col-md-4 col-lg-12 ">
                  <img src="../assets/KOVATEK/IMAGES/kovatek-note.png" class="card-img-top kova-img" alt="...">
              </div>
              <div class="col-sm-12 col-md-8 col-lg-12 ">
                <div class="card-body">
              <h6 class="card-title text-left font-weight-bold">Easy Payment</h6>
              <p class="card-text text-left">Fund your project account and initiate payment hourly or at a fixed-price to your developer(s), 
                anytime you want it.</p>
              </div>
            </div>
            </div>
          </div>
        </div>
       
      </div>
    </div> -->

    <div class="py-5 bg-light">
      <h2
        class="px-4 mb-5 mt-4 font-weight-bolder kovatek-text text-capitalize title-size"
      >
        How TalentAlt Works
      </h2>
      <div class="row ctrl-works m-auto">
        <div class="col-6 col-sm-6 col-md-3 my-2">
          <div class="w-75 text-left m-auto">
            <img
              src="../assets/KOVATEK/svg-embed/1.svg"
              class="w-25 ctrl-works-img mb-3"
              alt=""
            />
            <h5 class="kovatek-text ctrl-size font-weight-bold mb-3">
              Post a project
            </h5>
            <!-- <p class="font-weight-light ctrl-size2">Provide project information. Your project details helps the right talent to bid for your
              project task, and also help us suggest to you talent that matches your project field.
            </p> -->
          </div>
        </div>
        <div class="col-6 col-sm-6 col-md-3 my-2">
          <div class="w-75 text-left m-auto">
            <img
              src="../assets/KOVATEK/svg-embed/2.svg"
              class="w-25 ctrl-works-img mb-3"
              alt=""
            />
            <h5 class="kovatek-text ctrl-size font-weight-bold mb-3">
              Hire Developers
            </h5>
            <!-- <p class="font-weight-light ctrl-size2">Developers that meet your product requirement specifications will bid and/or assign for your project task. You
              review, approve and hire.
            </p> -->
          </div>
        </div>
        <div class="col-6 col-sm-6 col-md-3 my-2">
          <div class="w-75 text-left m-auto">
            <img
              src="../assets/KOVATEK/svg-embed/3.svg"
              class="w-25 ctrl-works-img mb-3"
              alt=""
            />
            <h5 class="kovatek-text ctrl-size font-weight-bold mb-3">
              Collaborate and Scale
            </h5>
            <!-- <p class="font-weight-light ctrl-size2">Hire all your developers and use TalentAlt project board to track your project activities. Your
                product development is enriched with TalentAlt management assistance.
            </p> -->
          </div>
        </div>
        <div class="col-6 col-sm-6 col-md-3 my-2">
          <div class="w-75 text-left m-auto">
            <img
              src="../assets/KOVATEK/svg-embed/4.svg"
              class="w-25 ctrl-works-img mb-3"
              alt=""
            />
            <h5 class="kovatek-text ctrl-size font-weight-bold mb-3">
              Easy Payment
            </h5>
            <!-- <p class="font-weight-light ctrl-size2">Fund your project account and initiate payment either based on milestone goals you set or at a
              fixed-price on completion to your developer team, only when you are 100% satisfied.
            </p> -->
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5 bg-light pt-5">
      <h2 class="font-weight-bold text-capitalize">connect with talents</h2>

      <form class="py-4 m-auto cont-w">
        <input
          type="email"
          class="w-75 my-3 mx-auto form-control input-height"
          id="email"
          placeholder="Company's email address"
        />
        <input
          type="password"
          class="w-75 my-3 mx-auto form-control input-height"
          id="pwd"
          placeholder="Password"
        />
        <input
          type="password"
          class="w-75 my-3 mx-auto form-control input-height"
          id="email"
          placeholder="Confirm Password"
        />
        <br />
        <div class="m-auto">
          <router-link to="/hire">
            <button class="btn btn-kovatek submit-w mb-4">Register</button>
          </router-link>
          <p>
            Already have an account?
            <router-link to="/login">Login</router-link>
          </p>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'howitworks',
};
</script>

<style scoped>
.w-90 {
  width: 90%;
}
.match-height {
  height: 480px;
}
.kova-img {
  height: 240px;
}

.input-height {
  height: 50px;
  font-size: 13px;
  width: 100%;
}
.submit-w {
  width: 300px;
}
.cont-w {
  width: 60%;
}
.btn-kovatek {
  background-color: #20409a;
  height: 50px;
  color: #fff;
  transition: 0.25s;
}
.btn-kovatek:hover {
  background-color: #06216d;
  color: #fff;
}
.title-size {
  font-size: 24px;
}
.ctrl-size {
  font-size: 16px;
}
.ctrl-works {
  width: 80%;
}
.ctrl-works-img {
  height: 100px;
}
@media screen and (min-width: 992px) and (max-width: 1325px) {
  .ctrl-works {
    width: 90%;
  }
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .cont-w {
    width: 75%;
  }
  .match-height {
    height: auto;
  }
  .ctrl-works {
    width: 100%;
  }
}
@media screen and (max-width: 767px) {
  .cont-w {
    width: 90%;
  }
  .match-height {
    height: auto;
  }
  .ctrl-works {
    width: 100%;
  }
}
</style>
